import axios from 'axios';
import { useAppStore } from '@/stores';

// Create axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 60000, // Request timeout
});

// request
service.interceptors.request.use(
  config => {
    const appStore = useAppStore();
    if (Object.keys(appStore.errors).length) {
      appStore.setErrors({});
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

export default service;
